import { Box, Grid, Heading, Text } from "@chakra-ui/react";
import { Reveal, RichText } from "@/components";
import { EXISTING_ASSETS, EXISTING_ASSETS_LABEL, PILLARS, PILLARS_LABEL, SHIFT_HEAD } from "@/content";

export const Shift = () => (
  <Box
    as="section"
    id="platform"
    className="print-flat"
    bg="surface.dark"
    color="ink.light"
    borderRadius="lg"
    mx="pad"
    px="pad"
    py="clamp(56px, 7vw, 112px)"
    mb="sec"
  >
    <Grid gap="18px" mb="head" justifyItems="center" textAlign="center">
      <Text variant="eyebrowBrand" color="brand.500">
        {SHIFT_HEAD.eyebrow}
      </Text>
      <Heading as="h2" variant="section" color="ink.light" maxW="20ch">
        {SHIFT_HEAD.title}
      </Heading>
      <Text variant="lede" color="ink.light2" maxW="52ch">
        <RichText nodes={SHIFT_HEAD.lede} />
      </Text>
    </Grid>

    <Grid
      maxW="1180px"
      mx="auto"
      gap="clamp(32px, 4vw, 56px)"
      templateColumns={{ base: "1fr", lg: "1fr auto 1fr" }}
      alignItems={{ lg: "start" }}
    >
      <Reveal>
        <Text variant="eyebrow" color="rgba(245, 243, 240, 0.55)" mb="28px">
          {EXISTING_ASSETS_LABEL}
        </Text>
        <Grid as="ul" role="list" gap="clamp(14px, 1.8vw, 22px)">
          {EXISTING_ASSETS.map((asset) => (
            <Box as="li" key={asset} display="flex" alignItems="center" gap="14px" fontSize="lede" fontWeight="light">
              <Box
                aria-hidden="true"
                w="8px"
                h="8px"
                borderRadius="50%"
                border="1.5px solid"
                borderColor="rgba(245, 243, 240, 0.35)"
                flexShrink={0}
              />
              {asset}
            </Box>
          ))}
        </Grid>
      </Reveal>

      <Box
        className="print-hide"
        aria-hidden="true"
        display={{ base: "none", lg: "block" }}
        position="relative"
        w="1px"
        alignSelf="stretch"
        bg="line.glassBorder"
      >
        <Box
          position="absolute"
          top="50%"
          left="50%"
          transform="translate(-50%, -50%)"
          w="40px"
          h="40px"
          display="grid"
          placeItems="center"
          borderRadius="50%"
          bg="surface.dark"
          border="1px solid"
          borderColor="line.glassBorder"
          color="brand.500"
        >
          →
        </Box>
      </Box>

      <Reveal>
        <Text variant="eyebrowBrand" color="brand.500" mb="28px">
          {PILLARS_LABEL}
        </Text>
        <Grid as="ul" role="list" gap="clamp(20px, 2.4vw, 28px)">
          {PILLARS.map((pillar) => (
            <Grid as="li" key={pillar.id} templateColumns="auto minmax(0, 1fr)" columnGap="14px">
              <Box aria-hidden="true" gridArea="1 / 1" w="8px" h="8px" borderRadius="50%" bg="brand.500" mt="0.55em" />
              <Heading
                as="h3"
                gridColumn={2}
                fontSize="lede"
                fontWeight="normal"
                lineHeight={1.1}
                color="ink.light"
                textTransform="none"
              >
                {pillar.title}
              </Heading>
              <Text
                className="print-muted"
                gridColumn={2}
                mt="6px"
                fontSize="small"
                lineHeight={1.45}
                color="rgba(245, 243, 240, 0.55)"
                sx={{ textWrap: "pretty" }}
              >
                {pillar.body}
              </Text>
            </Grid>
          ))}
        </Grid>
      </Reveal>
    </Grid>
  </Box>
);
